import useAuthStore from "@/store/authStore";
import { useRestaurant } from "../query/useRestaurant";
import { analytics } from "@/firebase";
import { logEvent } from "firebase/analytics";

// Custom hook to get the current restaurant for the authenticated user
export const useCurrentRestaurant = () => {
  const { user } = useAuthStore();

  logEvent(analytics, "use_current_restaurant_called", {
    userId: user?.uid ?? "no_user",
  });

  const restaurantId = user?.uid ?? "";
  const {
    data: restaurant,
    error,
    isLoading,
    refetch,
    updateRestaurant,
  } = useRestaurant(restaurantId);

  return {
    user,
    restaurant,
    restaurantId,
    error,
    isLoading,
    refetch,
    updateRestaurant,
  };
};
